import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { FieldOfExpertiseTermsQuery } from '@custom/schema';

export const useFieldOfExpertiseTermsQuery = () =>
  useStaticQuery(graphql(FieldOfExpertiseTermsQuery));
